import React from "react";
import { IndexedDB } from "react-indexed-db-hook";
import { DbConfig } from "./config/DbConfig";

const IndexedDBProvider = ({ children }) => {
  const config = DbConfig();
  return (
    <React.Fragment>
      <IndexedDB {...config}>{children}</IndexedDB>
    </React.Fragment>
  );
};

export default IndexedDBProvider;
